import { Avatar, HStack, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react';

// TODO: Replace all instances of tag lists in the admin area with this component.

interface AdminTagListProps {
  items: any;
  onRemove: (item: any) => void;
}

export default function AdminTagList({ items, onRemove }: AdminTagListProps) {
  return (
    <HStack flexWrap="wrap">
      {items.map((item: any) => (
        <Tag key={item.id} variant="create">
          <HStack>
            <Avatar size="xs" src={item.image} name={item.name || item.fullName} />

            <TagLabel>{item.name || item.fullName}</TagLabel>
          </HStack>

          <TagCloseButton onClick={() => onRemove(item)} />
        </Tag>
      ))}
    </HStack>
  );
}
